import 韻鏡位置 from './韻鏡位置';
import 韻鏡資料 from '../data/韻鏡資料';

/**
 * 迭代《韻鏡》所有字頭及其對應的韻鏡位置。
 */
export function* iter韻鏡字頭() {
  for (const line of 韻鏡資料) {
    const [字頭_轉號, 上位, 右位] = line.split(',');
    const [字頭, ...轉號_] = [...字頭_轉號];
    const 轉號 = 轉號_.join('');
    const 當前韻鏡位置 = new 韻鏡位置(Number(轉號), Number(上位), Number(右位));
    yield { 字頭, 韻鏡位置: 當前韻鏡位置 };
  }
}

const 韻鏡位置2字頭Map = new Map<string, string>();

for (const line of 韻鏡資料) {
  const [字頭_轉號, 上位, 右位] = line.split(',');
  const [字頭, ...轉號_] = [...字頭_轉號];
  const 轉號 = 轉號_.join('');
  const key = `${轉號}-${上位}-${右位}`;
  韻鏡位置2字頭Map.set(key, 字頭);
}

/**
 * 根據韻鏡位置取得字頭。若無對應字頭，則回傳 `undefined`。
 */
export const 韻鏡位置2字頭 = (當前韻鏡位置: 韻鏡位置): string | undefined => {
  const { 轉號, 上位, 右位 } = 當前韻鏡位置;
  const key = `${轉號}-${上位}-${右位}`;
  return 韻鏡位置2字頭Map.get(key);
};
